<!-- src/routes/+error.svelte -->
<script>
    import Footer from '$lib/components/footer.svelte';
	import imgOOPS from '$lib/images/img_OOPS.svg';
	import AppWrapper from '$lib/components/app-wrapper.svelte';
	import ButtonPrimary from '$lib/components/button-primary.svelte';
  </script>
  
 =
  <AppWrapper>
	<h1 class="text-white/50 text-center px-5 uppercase text-xl py-[18px] font-light tracking-[3px]">Error 404</h1>
		<div class="flex-1 flex flex-col items-center justify-center gap-10 text-center px-3">
			<img width="852" height="356" src={imgOOPS} alt="404"/>
			<p class="px-2 text-center text-white font-normal text-base md:text-xl -mt-8 md:-mt-16">We couldn't find the page you were looking for.</p>
			<div class="px-2 flex justify-center">
				<ButtonPrimary href="/design/landing" title="Go to Home Page" />
			</div>
		</div>
	<Footer />
</AppWrapper>
  